var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","label":"Filter by Timeframe","id":"filter-timeframe","items":_vm.timeFrame,"clearable":""},on:{"change":_vm.getTimeframe},model:{value:(_vm.detectionTime),callback:function ($$v) {_vm.detectionTime=$$v},expression:"detectionTime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }